export const date = (value, format) => {
    if (!value) return "";
    // eslint-disable-next-line no-undef
    return moment(value).format(format);
};
